import * as React from 'react'
import {
  ScrollView,
  ScrollViewProps,
  StyleProp,
  StyleSheet,
  View,
  ViewStyle,
  Platform,
  KeyboardAvoidingView,
  Dimensions,
} from 'react-native'

import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { useTheme } from '../../../hooks/theme.hook'
import { useGlobalStyles } from '../../../contexts/global-styles.provider'

type Props = ScrollViewProps & {
  children: React.ReactNode
  withScrollView?: boolean
  style?: StyleProp<ViewStyle>
  contentContainerStyle?: StyleProp<ViewStyle>
}

export function ScreenWrapper({
  children,
  withScrollView = true,
  style,
  contentContainerStyle,
  ...rest
}: Props) {
  const theme = useTheme()
  const insets = useSafeAreaInsets()
  const globalStyles = useGlobalStyles()
  const containerStyle = [
    globalStyles.pageContainer,
    {
      backgroundColor: theme.colors.surface,
      paddingBottom: insets.bottom,
      paddingLeft: insets.left,
      paddingRight: insets.right,
      // marginBottom: Platform.OS=='android'?insets.bottom:keyboardHeight,
    },
  ]

  // Web-specific keyboard handling
  const webScrollViewProps =
    Platform.OS === 'web'
      ? {
          keyboardShouldPersistTaps: 'handled' as const,
          showsVerticalScrollIndicator: false,
          alwaysBounceVertical: false,
          // Prevent extra scrollable space on web
          contentContainerStyle: contentContainerStyle
            ? {
                ...(contentContainerStyle as object),
                flexGrow: 1,
                minHeight: '100%',
              }
            : {
                flexGrow: 1,
                minHeight: '100%',
              },
        }
      : {}

  // Combine platform-specific props
  const scrollViewProps = Platform.OS === 'web' ? webScrollViewProps : {}

  return (
    <>
      {withScrollView ? (
        <KeyboardAvoidingView
          style={{ flex: 1 }}
          behavior={Platform.OS === 'ios' ? 'padding' : undefined}
          keyboardVerticalOffset={Platform.OS === 'ios' ? 0 : undefined}
        >
          <ScrollView
            {...rest}
            {...scrollViewProps}
            contentContainerStyle={
              Platform.OS === 'android' ? undefined : contentContainerStyle
            }
            alwaysBounceVertical={false}
            showsVerticalScrollIndicator={false}
            style={[containerStyle, style]}
          >
            {children}
          </ScrollView>
        </KeyboardAvoidingView>
      ) : (
        <KeyboardAvoidingView
          style={{ flex: 1 }}
          behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
          keyboardVerticalOffset={Platform.OS === 'ios' ? 0 : undefined}
        >
          <View
            style={[
              containerStyle,
              Platform.OS === 'web' && {
                overflow: 'hidden',
                height: Dimensions.get('window').height - 64,
              },
              style,
            ]}
          >
            {children}
          </View>
        </KeyboardAvoidingView>
      )}
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    height: '100%',
    flex: 1,
  },
})
